'use client';
import {
  createCompetitorProductMap,
  ProductStockStatus,
  ProductType,
  useCompetitorService,
  useRegionCurrency,
} from '@skin-seoul/service';
import { useProductService, useReviewService, getPriceProductBasicInfo } from '@skin-seoul/service';
import React, { useMemo } from 'react';
import { createReviewStatsMap } from '@skin-seoul/service';
import PriceOnAmazon from './components/PriceOnAmazon';
import { GridItem } from '@skin-seoul/design-system';
import { VerticalProductCard } from '../../components/ProductCard';

const ALLOWED_CURRENCY = ['USD', 'AUD', 'GBP', 'CAD'];

const AmazonProductList = () => {
  const { useGetProductsCollectionCompetitor } = useProductService();
  const { useGetReviewStatistics } = useReviewService();
  const { useGetCompetitorMatchedProducts } = useCompetitorService();
  const { currency } = useRegionCurrency();

  const { data } = useGetProductsCollectionCompetitor({
    collectionName: 'GGU Amazon Bestseller',
    competitorName: 'Amazon',
    currency: currency,
    stockStatus: ProductStockStatus.instock,
  });

  const products = useMemo(() => {
    return (data?.products?.length ? data.products : []).slice(0, 5);
  }, [data]);

  const { data: reviewStats } = useGetReviewStatistics({
    productIds: products.map((product) => product.productId).join(','),
  });

  const reviewStatsMap = useMemo(() => createReviewStatsMap(reviewStats), [reviewStats]);

  const { data: competitorData } = useGetCompetitorMatchedProducts({
    skus: products.map((product) => getPriceProductBasicInfo(product).sku),
    enabled: ALLOWED_CURRENCY.includes(currency),
  });

  const competitorProductsMap = useMemo(
    () => createCompetitorProductMap(competitorData, 'Amazon', currency),
    [competitorData, currency],
  );

  return (
    <React.Fragment>
      {products.map((product) => {
        const lowestPriceProductInfo = getPriceProductBasicInfo(product);
        const productReviewStats = reviewStatsMap[product.productId];
        const competitorProduct = competitorProductsMap[product.sku];

        return (
          <GridItem key={product.productId + 'amazon-product-list'} minWidth={0}>
            <VerticalProductCard
              href={product.productLink}
              productType={ProductType.Variable}
              key={product.productId}
              name={product.name}
              brand={product.brand}
              productImage={product.productImageUrls[0] || ''}
              sku={product.sku}
              currency={product.currency}
              originalPrice={lowestPriceProductInfo.originalPrice}
              salePrice={lowestPriceProductInfo.salePrice}
              rating={productReviewStats?.averageRate}
              reviewCount={productReviewStats?.totalReviews}
              onClick={() => (window.location.href = product.productLink)}
              theme="dark"
            >
              <VerticalProductCard.Image
                bottomSlot={<PriceOnAmazon price={competitorProduct?.price.salesPrice} currency={product.currency} />}
              />
              <VerticalProductCard.Content>
                <VerticalProductCard.InfoName />
                <VerticalProductCard.InfoRating />
                <VerticalProductCard.InfoPrice />
              </VerticalProductCard.Content>
            </VerticalProductCard>
          </GridItem>
        );
      })}
    </React.Fragment>
  );
};

export default AmazonProductList;
